export function formatAmount(amount?: number): string {
  return amount != null ? `¥${amount.toLocaleString()}` : '-';
}
